import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { Button } from 'foundations-components/transitional/components/Button';
import { useState } from 'react';
import SuiteFeatureTable from '../feature-table/suite-feature-table/SuiteFeatureTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileSuiteFeatureTable = ({
  productsByProductLine,
  screen
}) => {
  const [showFeaturesTable, setShowFeaturesTable] = useState(false);
  const toggleFeatureTable = evt => {
    evt.preventDefault();
    setShowFeaturesTable(prev => !prev);
  };
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "100",
    children: [/*#__PURE__*/_jsx(Button, {
      use: "transparent",
      onClick: toggleFeatureTable,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: showFeaturesTable ? 'suiteFeatureTable.mobile.hideAll' : 'suiteFeatureTable.mobile.seeAll'
      })
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      duration: 500,
      renderContent: () => /*#__PURE__*/_jsx(SuiteFeatureTable, {
        productsByProductLine: productsByProductLine,
        screen: screen
      }),
      open: showFeaturesTable
    })]
  });
};
export default MobileSuiteFeatureTable;